import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ContentWrapper from "../../../Wrapper";
import * as whatsAppAccountActions from "../../store/actions/whatsapp_account_list_actions";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import { ContentWithCardLoading } from "../../../../components/loading";
import { CustomSubHeader } from "../../../../components/subheader";
import { Form } from "react-bootstrap";
import _ from "lodash";

export default function WhatsAppAccountList() {
  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [search, setSearch] = useState("");
  const [hideTestAccounts, setHideTestAccounts] = useState(true); 
  const dispatch = useDispatch();
  
  const offset = (pageNo - 1) * limit;
  const allWhatsAppAccounts = useSelector((state) => state.whatsAppAccounts.allAccounts);
  const totalCount = useSelector((state) => state.whatsAppAccounts.allAccounts.Count);

  useEffect(() => {
    dispatch(whatsAppAccountActions.getListOfWhatsAppAccountsRequest({ limit, offset, search , filterTestAccounts : hideTestAccounts }));
    dispatch(whatsAppAccountActions.getCountOfWhatsAppAccounts({ search , filterTestAccounts : hideTestAccounts }));
  }, [dispatch, search, pageNo, limit , offset , hideTestAccounts]);

  const debouncedSearch = useCallback(
    _.debounce((searchText) => {
      dispatch(whatsAppAccountActions.getListOfWhatsAppAccountsRequest({ search: searchText, limit, offset: 0 , filterTestAccounts : hideTestAccounts}));
      dispatch(whatsAppAccountActions.getCountOfWhatsAppAccounts({ search: searchText , filterTestAccounts : hideTestAccounts}));
    }, 500),
    [dispatch, limit , hideTestAccounts]
  );

  const handleSearchChange = (e) => {
    const searchText = e.target.value;
    setSearch(searchText);
    setPageNo(1);
    debouncedSearch(searchText);
  };

  const handlePageChange = (page) => {
    setPageNo(page);
    const newOffset = (page - 1) * limit;
    dispatch(whatsAppAccountActions.getListOfWhatsAppAccountsRequest({ limit, offset: newOffset, search , filterTestAccounts : hideTestAccounts}));
  };

  const handleSwitchChange = (e) => {
    const isChecked = e.target.checked;
    setHideTestAccounts(isChecked); 
    setPageNo(1);
    dispatch(whatsAppAccountActions.getListOfWhatsAppAccountsRequest({ limit, offset : 0 , filterTestAccounts : isChecked , search}));
    dispatch(whatsAppAccountActions.getCountOfWhatsAppAccounts({ search , filterTestAccounts : isChecked }));
  };
  
  
  return (
    <ContentWrapper subHeader={<CustomSubHeader>
      <div className="d-flex w-100 flex-stack" style={{ justifyContent: 'flex-end' }}>
        <div className="w-200px">
        <Form.Check 
            type="switch"
            id="hide-test-accounts"
            label="Hide Test Accounts"
            checked={hideTestAccounts}
            onChange={handleSwitchChange}
          />
        </div>
        <div className="w-300px">
          <Form.Control
            value={search}
            onChange={handleSearchChange}
            placeholder="Search here..."
          />
        </div>
      </div>
    </CustomSubHeader>}>
      {allWhatsAppAccounts.loading ? (
        <ContentWithCardLoading />
      ) : !allWhatsAppAccounts?.data || allWhatsAppAccounts.data.length === 0 ? ( 
        "No accounts"
      ) : (
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "WhatsApp Account Name", apiKeyName: "businessName", fieldInputType: "INPUT" },
                { title: "Owner Full Name", apiKeyName: "displayName", fieldInputType: "INPUT" },
                { title: "Owner Email", apiKeyName: "email", fieldInputType: "INPUT" },
                { title: "Connected Number", apiKeyName: "connectedNumber", fieldInputType: "INPUT" },
                { title: "WABA Id", apiKeyName: "wabaId", fieldInputType: "INPUT" },
                { title: "Phone Id", apiKeyName: "phoneId", fieldInputType: "INPUT" },
                { title: "Vendor", apiKeyName: "vendor", fieldInputType: "INPUT" },
                { title: "Added Date", apiKeyName: "addedDate", fieldInputType: "DATE_TIME" },
                { title: "Tier", apiKeyName: "tier", fieldInputType: "INPUT" }
              ]}
              data={allWhatsAppAccounts.data}
              limit={limit}
              pageNo={pageNo}
              setLimit={setLimit}
              setPageNo={handlePageChange}
              count={totalCount}
            />
          </div>
        </div>
      )}
    </ContentWrapper>
  );
}
